const CURRENT_LANGUAGE = 'language';

export const getLanguage = (): string | null => localStorage.getItem(CURRENT_LANGUAGE);
export const setLanguage = (language: string): void => localStorage.setItem(CURRENT_LANGUAGE, language);
export const removeLanguage = (): void => localStorage.removeItem(CURRENT_LANGUAGE);
